import React from 'react';

import Landing from './sections/Landing.js';

import './App.css';

function App() {
  return (
    <main className="App">
      <Landing />
    </main>
  );
}

export default App;
